module.exports = __webpack_public_path__ + "static/media/8010.380674e6.jpg";